<template>
  <el-collapse v-model="layout.filtersOpen">
    <el-collapse-item :title="$t('common.search')" name="search-section" id="layout-search-section">
      <el-form
        id="layout-search-section-form"
        :model="searchForm"
        ref="searchForm"
        label-position="right"
        size="mini"
        class="search-section-form"
        inline
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('layout.dateFrom')" prop="layoutDateFrom">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                @change="handleSearch"
                v-model="searchForm.layoutDateFrom"
                format="MM/dd/yyyy"
                clearable
                type="date"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('layout.dateTo')" prop="layoutDateTo">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                @change="handleSearch"
                v-model="searchForm.layoutDateTo"
                format="MM/dd/yyyy"
                clearable
                type="date"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('layout.layoutTemplate')" prop="parentLayoutSearch">
              <el-input
                v-model="searchForm.parentLayoutSearch"
                ref="filter-layout-template"
                v-alphanumeric-validation
                maxlength="50"
                clearable
                @clear="handleSearch"
                v-on:keyup.enter.native="handleSearch"
                class="inline-input"
                id="search-form-layout-template"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24" class="text-align-end">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('common.search')"
              placement="top-start"
            >
              <el-button
                id="form-search-button"
                @click="handleSearch"
                icon="el-icon-search"
                size="mini"
                class="button-action-default"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LayoutSearchFilters',
  computed: {
    ...mapGetters(['layout'])
  },
  data() {
    return {
      searchForm: {
        layoutDateFrom: new Date(),
        layoutDateTo: null,
        parentLayoutSearch: null
      },
      activeCollapsibleName: ['search-section']
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch('layout/search', this.searchForm);
    }
  }
};
</script>
